import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTheme } from "../../redux/slice/selectionsSlice";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";

const ThemeSwitchButton = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);

  const customLightThemeObj = {
    name: "Light mode",
    boolValue: false,
    key: "light",
  };
  const customDarkThemeObj = {
    name: "Dark mode",
    boolValue: true,
    key: "dark",
  };

  const getThemeDetails = (appTheme) => {
    if (appTheme === "light") {
      return customDarkThemeObj;
    } else if (appTheme === "dark") {
      return customLightThemeObj;
    } else {
      const isDarkMode = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      return isDarkMode ? customLightThemeObj : customDarkThemeObj;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "5px",
        height: theme.size[30],
      }}
    >
      <Typography
        sx={{
          fontWeight: theme.fontWeight[400],
          fontSize: theme.size[12],
          lineHeight: theme.size[18],
          color: theme.palette.cards.heading,
        }}
      >
        {isDarkMode === "dark"
          ? "Dark mode"
          : isDarkMode === "light"
          ? "Light mode"
          : window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "Dark Mode"
          : "Light Mode"}
      </Typography>
      <FormControlLabel
        sx={{ marginRight: "-7px" }}
        control={
          <Switch
            checked={getThemeDetails(isDarkMode)?.boolValue}
            onClick={() => {
              const chosenValue = getThemeDetails(isDarkMode)?.key;
              dispatch(updateTheme(chosenValue));
            }}
          />
        }
      />
    </Box>
  );
};

export default ThemeSwitchButton;
